import "./EventBanner.css";
import eventBannerImgEN from "asset/image/20230419_Benefit_en_900.png";
import eventBannerImgKO from "asset/image/20230419_Benefit_kr_900.png";
import closeIcon from "asset/icon/ic_close_white_24dp.svg";
import {useEffect, useState} from "react";
import i18n from "../../../lang/i18n";

const EventBanner = (props) =>{
    const {bannerOpen,handleEventBannerClose} = props;
    const [eventBannerImg, setEventBannerImg] = useState(eventBannerImgEN);

    useEffect(()=>{
        if(i18n.language === "en-US"){
            setEventBannerImg(eventBannerImgEN);
        }else if(i18n.language === "ko-KR"){
            setEventBannerImg(eventBannerImgKO);
        }

    },[i18n.language]);

    return (
        <>
            <div className={`event-banner ${bannerOpen}`}>
                <img className={"event-banner-close"}
                     src={closeIcon}
                     alt={"close"}
                    onClick={handleEventBannerClose}
                />

                <img className={"event-banner-img"} src={eventBannerImg} alt={"event"}/>
            </div>
        </>
    );
}

export default EventBanner;